import React, {memo} from "react";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {COLLAPSED_NESTED_NODE_HEIGHT, NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import Divider from "./Divider";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledNestedNodeDiv = styled.div`
  //width: 100%;
  height: ${props => props.$isNodeCollapsed ? COLLAPSED_NESTED_NODE_HEIGHT : "auto"};
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
`;

const StyledRemoveButtonContainerDiv = styled.div`
  margin-bottom: 8px;
`;

const StyledRemoveButtonControlWrapperDiv = styled.div`
  margin: 0px ${NESTED_NODE_HORIZONTAL_MARGIN};
  display: flex;
  justify-content: end;
`;

const StyledInfoControlsContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  margin-right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledIconFileControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  width: 100%;
  > div {
      width: 100% !important;
      flex: 1 !important;
  }
`;

const StyledTextControlContainerDiv = styled.div`
    display: flex;
    flex: 1;
    align-self: stretch;
    margin-top: 16px;
`;

const StyledTextControlWrapperDiv = styled.div`
    width: 100%;
    > div {
        height: ${props => props.$isNodeCollapsed ? "38px" : "76px"};
    }
`;

const Infos = ({controls, bindControl, isNodeCollapsed}) => {
    let nestedNodes = [];
    let nestedNodesIds = new Map();
    controls.forEach(control => {
        const infoUUID = control.key.split('_')[0];
        if (nestedNodesIds.has(infoUUID)) return;
        nestedNodesIds.set(infoUUID, "");
        const iconRemoveButtonControl = controls.find(control => control.key.includes(SequenceComponentHelper.getInfoRemoveButtonKey(infoUUID)));
        const iconControl = controls.find(control => control.key.includes(SequenceComponentHelper.getInfoIconFileKey(infoUUID)));
        const textControl = controls.find(control => control.key.includes(SequenceComponentHelper.getInfoTextKey(infoUUID)));
        nestedNodes.push({key: infoUUID, removeButtonControl: iconRemoveButtonControl, iconControl: iconControl, textControl: textControl})
    });

    nestedNodes.sort((a, b) => a.order - b.order);

    return (
        <>
            {nestedNodes.map((nestedNode, index) => (
                <div key={nestedNode.key}>

                    {/** NESTED NODE - INFO */}
                    <StyledNestedNodeDiv $isNodeCollapsed={isNodeCollapsed}>

                        {/** REMOVE BTN */}
                        {!isNodeCollapsed &&
                            <StyledRemoveButtonContainerDiv>
                                <StyledRemoveButtonControlWrapperDiv>
                                    <Control key={nestedNode.removeButtonControl.key}
                                             control={nestedNode.removeButtonControl}
                                             innerRef={bindControl}/>
                                </StyledRemoveButtonControlWrapperDiv>
                            </StyledRemoveButtonContainerDiv>
                        }

                        {/** INFO CONTROLS */}
                        <StyledInfoControlsContainerDiv>

                            {/** ICON CONTROL */}
                            <StyledIconFileControlContainerDiv>
                                <Control key={nestedNode.iconControl.key}
                                         control={nestedNode.iconControl}
                                         innerRef={bindControl}/>
                            </StyledIconFileControlContainerDiv>

                            {/** TEXT CONTROL */}
                            {!isNodeCollapsed &&
                                <StyledTextControlContainerDiv>
                                    <StyledTextControlWrapperDiv>
                                        <Control key={nestedNode.textControl.key}
                                                 control={nestedNode.textControl}
                                                 innerRef={bindControl}/>
                                    </StyledTextControlWrapperDiv>
                                </StyledTextControlContainerDiv>
                            }

                        </StyledInfoControlsContainerDiv>

                    </StyledNestedNodeDiv>
                    {(index !== nestedNodes.length - 1) && <Divider height={1}/>}
                </div>
            ))}
        </>
    );
}

export default memo(Infos);